<template>
<div class="chapter">
<div class="inner_page">
<p><a id="als"></a></p>
<div class="ctag1">Also by Marie-Monique Robin</div>
<div> <br/></div><div class="ctag1"><i>Voleurs d’organes: Enquête sur un trafic</i> <br/><i>Les Cent Photos du siècle</i> <br/><i>Le Sixième Sens: Science et paranormal (with Mario Varvoglis)</i> <br/><i>Escadrons de la mort, l’école française</i> <br/><i>L’École du soupçon: Les dérives de la lutte contre la pédophilie</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// mari_9781595585363_oeb_als_r1.vue?1c4152b7